// A2-581 screen map lead 35: "is this calculation signed off?" was read four
// ways (signoff_id; signed_off_at; signed_off_at || signed_off_by;
// signoff_id || signed_off_at). The sign-off route writes all three together
// (backend api/routes_signoff.py); the server's own guards test signoff_id.
// One reading for every screen: the record's id, or its timestamp for a
// response that projects only that.
export const isSignedOff = (calc) => !!(calc && (calc.signoff_id || calc.signed_off_at));
